export const platformMixins = {
  computed: {
    platforms() {
      return user?.platforms ?? []
    },
    isPlatform() {
      return this.platforms.length > 0
    },
    isPlatformSalesman() {
      return user?.isPlatformSalesman ?? false
    },
    isClient() {
      return !!(!this.isPlatformSalesman && conf.connect_client)
    },
    isCompany() {
      return user?.entity?.isCompany ?? false
    },
    isPlatformClient() {
      return user?.isPlatformClient ?? false
    },
    defaultPlatform() {
      if (this.platforms.length === 0) {
        return null
      }

      for (let platform of this.platforms) {
        if (platform.id === user.entity.id) {
          return platform
        }
      }

      if (this.platforms.length === 1) {
        return this.platforms[0]
      }

      return null
    },
    defaultPlatformId() {
      if (!!this.defaultPlatform) {
        return this.defaultPlatform.id
      }

      return null
    },
    defaultPlatformParamId() {
      if (this.defaultPlatform?.platformParams.length === 1) {
        return this.defaultPlatform.platformParams[0].id
      }

      return null
    },
  },
  methods: {
    getPlatformById(id) {
      for (let platform of this.platforms) {
        if (Number(platform.id) === Number(id)) {
          return platform
        }
      }

      return null
    },
  },
}
